<div class="dlg-hdr">
  <div class="dlg-hdr__title">
    <div class="dlg-hdr__icon-wrap"><mat-icon>attachment</mat-icon></div>
    <div>
      <span>Importar cuadro de amortización</span>
      <small class="dlg-hdr__sub">Fichero Excel (.xlsx)</small>
    </div>
  </div>
  <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dlg-body">
  <div class="dlg-upload">
    <label for="img-input" class="dlg-upload__btn">
      <mat-icon>file_upload</mat-icon>
      <span>Seleccionar Excel</span>
    </label>
    <input matinput id="img-input" type="file" (change)="uploadFile($event)" placeholder="Upload file" accept=".xlsx">

    <ng-container *ngIf="loadingFile">
      <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </ng-container>
  </div>
</mat-dialog-content>
